import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MoodleAdministrationPage from './pages/MoodleAdministrationPage';
import MoodleWizardPage from './pages/MoodleWizardPage';
import './styles/App.css';
import './styles/MoodleAdministration.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/administracion-moodle" element={<MoodleAdministrationPage />} />
        <Route path="/configurar-moodle" element={<MoodleWizardPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
